"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultStyles = void 0;
var defaultStyles = {
  fontSize: 12,
  color: '#000000',
  font: 'Roboto'
};
exports.defaultStyles = defaultStyles;
var _default = {
  _h1: {
    fontSize: 24,
    bold: true
  },
  _h2: {
    fontSize: 20,
    bold: true
  },
  _h3: {
    fontSize: 18,
    bold: true
  },
  _h4: {
    fontSize: 16,
    bold: true
  },
  _h5: {
    fontSize: 14,
    bold: true
  },
  _h6: {
    fontSize: 12,
    bold: true
  },
  _p: {
    fontSize: 12
  },
  _small: {
    fontSize: 10
  },
  _b: {
    bold: true
  },
  _em: {
    italics: true
  },
  _a: {
    decoration: 'underline',
    color: 'blue'
  }
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/styles.js
// module id = 58
// module chunks = 0